export const Binoculars = (
  <svg width="100%" height="100%" viewBox="0 0 40 23" version="1.1">
    <title>binoculars</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.439227 0 0 0 0 0.422823 0 0 0 0 0.407590 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g filter="url(#filter-1)" id="binoculars">
        <g>
          <path
            d="M36.2414873,5.69580426 C36.2418004,5.68795028 36.2426614,5.68025496 36.2426614,5.67232164 L36.2426614,5.03765628 C36.2426614,3.30977984 34.8555773,1.90399608 33.1506849,1.90399608 L29.5245401,1.90399608 C28.583953,0.706303211 27.1526419,0 25.6360078,0 C24.1193738,0 22.6881409,0.706303211 21.7474755,1.90399608 L18.2524462,1.90399608 C17.3118591,0.706303211 15.8805479,0 14.3639139,0 C12.8472798,0 11.416047,0.706303211 10.4753816,1.90399608 L6.84931507,1.90399608 C5.1444227,1.90399608 3.75733855,3.30977984 3.75733855,5.03765628 L3.75733855,5.67232164 C3.75733855,5.68025496 3.75819961,5.68795028 3.75851272,5.69580426 C1.47827789,7.42629869 0,10.185665 0,13.2883059 C0,18.5158065 4.19624266,22.7686197 9.35420744,22.7686197 C14.5121722,22.7686197 18.7084149,18.5158065 18.7084149,13.2883059 C18.7084149,12.955662 18.691272,12.627064 18.6580822,12.3031466 C19.0641879,12.5022729 19.5194521,12.613974 20,12.613974 C20.4805479,12.613974 20.9358121,12.5021936 21.3419178,12.3031466 C21.308728,12.627064 21.2915851,12.955662 21.2915851,13.2883059 C21.2915851,18.5158065 25.4878278,22.7686197 30.6457926,22.7686197 C35.8037573,22.7686197 40,18.5158065 40,13.2883059 C40,10.185665 38.5217221,7.42629869 36.2414873,5.69580426 L36.2414873,5.69580426 Z M25.6360078,1.18999755 C26.4325636,1.18999755 27.1977299,1.44664035 27.8322505,1.90399608 L23.4398434,1.90399608 C24.0742857,1.44664035 24.8394521,1.18999755 25.6360078,1.18999755 L25.6360078,1.18999755 Z M14.3639922,1.18999755 C15.1605479,1.18999755 15.9257143,1.44664035 16.5602348,1.90399608 L12.1678278,1.90399608 C12.8022701,1.44664035 13.5674364,1.18999755 14.3639922,1.18999755 L14.3639922,1.18999755 Z M9.35420744,21.5786222 C4.84367906,21.5786222 1.1741683,17.8596419 1.1741683,13.2883059 C1.1741683,8.71697003 4.84367906,4.9979897 9.35420744,4.9979897 C13.8647358,4.9979897 17.5342466,8.71697003 17.5342466,13.2883059 C17.5342466,17.8596419 13.8647358,21.5786222 9.35420744,21.5786222 L9.35420744,21.5786222 Z M18.0821918,9.48031379 C18.0821918,8.408602 18.942544,7.53665113 20,7.53665113 C21.057456,7.53665113 21.9178082,8.408602 21.9178082,9.48031379 C21.9178082,10.5520256 21.057456,11.4239765 20,11.4239765 C18.942544,11.4239765 18.0821918,10.5520256 18.0821918,9.48031379 L18.0821918,9.48031379 Z M20,6.34665359 C18.7679061,6.34665359 17.7020744,7.08104074 17.2055577,8.14045589 C15.5366732,5.53507526 12.6408611,3.80799215 9.35420744,3.80799215 C7.7564775,3.80799215 6.25127202,4.21639931 4.9341683,4.93507849 C4.98700587,3.91088727 5.82575342,3.09399362 6.84931507,3.09399362 L10.7599217,3.09399362 L10.7601566,3.09399362 L17.9584344,3.09399362 L17.9590607,3.09399362 L17.9596086,3.09399362 L22.0320157,3.09399362 L22.0322505,3.09399362 L29.2305284,3.09399362 L29.2311546,3.09399362 L29.2317025,3.09399362 L33.1506849,3.09399362 C34.1742466,3.09399362 35.0129941,3.91088727 35.0658317,4.93507849 C33.748728,4.21639931 32.2435225,3.80799215 30.6457926,3.80799215 C27.3591389,3.80799215 24.4633268,5.53507526 22.7944423,8.14045589 C22.2979256,7.08104074 21.2320939,6.34665359 20,6.34665359 L20,6.34665359 Z M30.6457926,21.5786222 C26.1352642,21.5786222 22.4657534,17.8596419 22.4657534,13.2883059 C22.4657534,8.71697003 26.1352642,4.9979897 30.6457926,4.9979897 C35.1563209,4.9979897 38.8258317,8.71697003 38.8258317,13.2883059 C38.8258317,17.8596419 35.1563209,21.5786222 30.6457926,21.5786222 L30.6457926,21.5786222 Z"
            id="Shape"
            fill="#DCB970"
          ></path>
          <path
            d="M30.5862846,6.79024892 C27.0836935,6.79024892 24.2341722,9.67822153 24.2341722,13.2280764 C24.2341722,16.7779312 27.0836935,19.6659039 30.5862846,19.6659039 C34.0888757,19.6659039 36.9383971,16.7779312 36.9383971,13.2280764 C36.9383971,9.67822153 34.0888757,6.79024892 30.5862846,6.79024892 L30.5862846,6.79024892 Z M30.5862846,18.5622763 C27.6841315,18.5622763 25.3231057,16.169391 25.3231057,13.2280764 C25.3231057,10.2867618 27.6841315,7.89387648 30.5862846,7.89387648 C33.4884378,7.89387648 35.8494635,10.2867618 35.8494635,13.2280764 C35.8494635,16.169391 33.4884378,18.5622763 30.5862846,18.5622763 L30.5862846,18.5622763 Z"
            id="Shape"
            fill="#DCB970"
          ></path>
          <path
            d="M9.35420744,6.84946945 C5.85102348,6.84946945 3.00101982,9.73789471 3.00101982,13.2883059 C3.00101982,16.8387172 5.85102348,19.7271424 9.35420744,19.7271424 C12.8573914,19.7271424 15.7073951,16.8387172 15.7073951,13.2883059 C15.7073951,9.73789471 12.8573914,6.84946945 9.35420744,6.84946945 L9.35420744,6.84946945 Z M9.35420744,18.6233419 C6.45156308,18.6233419 4.0901377,16.2300816 4.0901377,13.2883059 C4.0901377,10.3465303 6.45156308,7.95326999 9.35420744,7.95326999 C12.2568518,7.95326999 14.6182772,10.3465303 14.6182772,13.2883059 C14.6182772,16.2300816 12.2568518,18.6233419 9.35420744,18.6233419 L9.35420744,18.6233419 Z"
            id="Shape"
            fill="#DCB970"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const Bird = (
  <svg width="100%" height="100%" viewBox="0 0 241 203" version="1.1">
    <defs>
      <linearGradient
        x1="103.072126%"
        y1="24.4879914%"
        x2="50%"
        y2="63.0937424%"
        id="linearGradient-1"
      >
        <stop stopColor="#F2EDE4" offset="0%"></stop>
        <stop stopColor="#CAC3BB" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0.997049825%"
        x2="50%"
        y2="80.5998689%"
        id="linearGradient-2"
      >
        <stop stopColor="#FFF4EA" offset="0%"></stop>
        <stop stopColor="#E0CFB5" offset="80.5998689%"></stop>
        <stop stopColor="#CAC3BB" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0.997049825%"
        x2="50%"
        y2="80.5998689%"
        id="linearGradient-3"
      >
        <stop stopColor="#FFF4EA" offset="0%"></stop>
        <stop stopColor="#E0CFB5" offset="80.5998689%"></stop>
        <stop stopColor="#CAC3BB" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0.997049825%"
        x2="50%"
        y2="80.5998689%"
        id="linearGradient-4"
      >
        <stop stopColor="#FFF4EA" offset="0%"></stop>
        <stop stopColor="#E0CFB5" offset="80.5998689%"></stop>
        <stop stopColor="#CAC3BB" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="art" transform="translate(-51.000000, -2.000000)">
        <g id="bird" transform="translate(51.000000, 2.476930)">
          <path
            d="M214.797615,95.2272347 C231.857082,99.4266924 241,115.446753 241,115.446753 C198.648234,106.040518 195.105901,133.668794 195.105901,133.668794 C176.662857,202.876361 95.4530544,209.357139 62.2111365,195.701918 C40.0498579,186.598437 28.6461457,165.920729 28,133.668794 C34.8667337,160.469621 56.2135114,171.134815 92.0403332,165.664374 C145.780566,157.458714 149.828616,111.601437 169.777238,100.096808 C186.266849,91.0559659 197.738148,91.0277769 214.797615,95.2272347 Z M147.878677,178.796183 C131.711938,194.299244 116.465741,198.091476 116.465741,198.091476 C154.593941,192.681171 179.762905,172.170795 191.972631,136.560347 C173.70552,132.324119 159.007535,146.402731 147.878677,178.796183 Z M205.160617,96.6804187 C203.19721,96.6804187 201.605555,98.2758261 201.605555,100.243861 C201.605555,102.211896 203.19721,103.807303 205.160617,103.807303 C207.124024,103.807303 208.71568,102.211896 208.71568,100.243861 C208.71568,98.2758261 207.124024,96.6804187 205.160617,96.6804187 Z"
            id="Combined-Shape"
            fill="url(#linearGradient-1)"
          ></path>
          <path
            d="M130.92102,149.641601 C133.084806,155.919679 105.453717,125.26053 130.930525,96.5166605 C156.407332,67.7727914 175.202541,79.7653501 188.049959,59.9952957 C196.614904,46.8152594 194.320404,28.1966661 181.166457,4.13951572 C182.429064,23.4960445 179.479602,36.4105133 172.31807,42.8829222 C162.056669,52.1569133 137.166226,46.0994418 115.774678,69.1093929 C78.9338036,117.62672 125.388594,151.55406 130.92102,149.641601 Z"
            id="Path-3"
            fill="url(#linearGradient-2)"
            transform="translate(147.404490, 77.303509) rotate(5.000000) translate(-147.404490, -77.303509) "
          ></path>
          <path
            d="M80.0679092,156.508076 C81.7317453,162.793 60.5411885,132.084319 80.0147993,103.342472 C99.4884102,74.6006259 113.892569,86.6200926 123.706705,66.8470197 C130.249462,53.6649711 128.471517,35.0299597 118.372869,10.9419855 C119.361585,30.3145241 117.118013,43.2360982 111.642153,49.7067078 C103.796067,58.9781208 84.7318468,52.8925364 68.3795918,75.8999279 C40.2275747,124.419653 75.8341884,158.41678 80.0679092,156.508076 Z"
            id="Path-3"
            fill="url(#linearGradient-3)"
            transform="translate(92.602332, 84.138262) rotate(-38.000000) translate(-92.602332, -84.138262) "
          ></path>
          <path
            d="M59.3179189,183.96589 C60.4104267,189.183928 46.4886609,163.69378 59.2912327,139.819283 C72.0938044,115.944787 84.3712793,117.395295 90.8242221,100.97228 C95.126184,90.0236036 93.4156055,75.1917252 85.6924865,56.4766447 C89.6027639,79.7563071 87.1922517,92.285785 78.46095,94.0650783 C65.3639974,96.7340183 62.3990918,97.9256035 51.6487731,117.037088 C33.1396635,157.338101 56.5352069,185.552629 59.3179189,183.96589 Z"
            id="Path-3"
            fill="url(#linearGradient-4)"
            transform="translate(68.858686, 120.564411) rotate(-72.000000) translate(-68.858686, -120.564411) "
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const BirdBox = (
  <svg width="100%" height="100%" viewBox="0 0 41 43" version="1.1">
    <title>birdbox</title>
    <g id="Colors" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="birdbox" transform="translate(1.000000, 1.000000)">
        <path
          d="M20.6693538,4.63854482 L34.7346922,18.0564837 C34.9325051,18.2451917 35.0444336,18.5066591 35.0444336,18.7800465 L35.0444336,39 C35.0444336,40.1045695 34.1490031,41 33.0444336,41 L6,41 C4.8954305,41 4,40.1045695 4,39 L4,18.7983264 C4,18.5142611 4.12081142,18.2436007 4.33227082,18.0539221 L19.3113661,4.61770328 C19.7000513,4.26905343 20.2915509,4.27813139 20.6693538,4.63854482 Z"
          id="Path"
          strokeWidth="1.5"
          fillRule="nonzero"
        ></path>
        <circle id="Oval" cx="19.5" cy="19.5" r="7"></circle>
        <circle id="Oval" cx="19.5" cy="34.5" r="3"></circle>
        <path
          d="M0,18 L18.7077412,1.23277291 C19.4844303,0.536648138 20.6656769,0.554260054 21.4212674,1.2732305 L39,18 L39,18"
          id="Path-6"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>
      </g>
    </g>
  </svg>
);

export const Compass = (
  <svg width="100%" height="100%" viewBox="0 0 40 40" version="1.1">
    <title>compass</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.439227 0 0 0 0 0.422823 0 0 0 0 0.407590 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
      <filter id="filter-2">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.439227 0 0 0 0 0.422823 0 0 0 0 0.407590 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="Colors" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="compass">
        <g>
          <path
            d="M20,5.53595658 L20,7.01221167 M34.4418312,19.9294437 L32.9655762,19.9294437 M20,34.3229308 L20,32.8466757 M5.55816875,19.9294437 L7.03442384,19.9294437"
            id="Line"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
          <ellipse
            id="base"
            strokeWidth="2"
            cx="20.0610368"
            cy="19.9996131"
            rx="18.93758"
            ry="18.8765918"
          ></ellipse>
          <g id="direction">
            <g transform="translate(19.566944, 20.545251) rotate(45.000000) translate(-19.566944, -20.545251) translate(15.066944, 9.045251)">
              <path
                d="M4.336,2.357 L7.22345144,10.0326414 C7.46107877,10.6756569 7.46266818,11.7294651 7.22345144,12.3767815 L7.22345144,12.3767815 L4.386,20.053 L1.4992398,12.3767815 C1.28537521,11.7980675 1.26270132,10.8866115 1.43469419,10.2382138 L1.4992398,10.0326414 L4.336,2.357 Z"
                id="Path-5"
                strokeWidth="2"
              ></path>
              <line
                x1="1.34043612"
                y1="10.6164661"
                x2="7.45123536"
                y2="10.6164661"
                id="Line"
                strokeWidth="2"
                strokeLinecap="round"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const DateIcon = (
  <svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1">
    <g
      id="Colors"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.703334263"
    >
      <g id="Light-Mode/Icons/Date">
        <polygon id="State" points="0 0 24 0 24 24 0 24"></polygon>
        <path
          d="M9,11 L7,11 L7,13 L9,13 L9,11 L9,11 Z M13,11 L11,11 L11,13 L13,13 L13,11 L13,11 Z M17,11 L15,11 L15,13 L17,13 L17,11 L17,11 Z M19,4 L18,4 L18,2 L16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L5,4 C3.89,4 3.01,4.9 3.01,6 L3,20 C3,21.1 3.89,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 L19,4 Z M19,20 L5,20 L5,9 L19,9 L19,20 L19,20 Z"
          id="Icon"
          fill="#292B2B"
        ></path>
      </g>
    </g>
  </svg>
);

export const AccountCircle = (
  <svg width="100%" height="100%" viewBox="0 0 21 20" version="1.1">
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.957693 0 0 0 0 0.918407 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="ic_account_circle"
        transform="translate(-1.373832, -2.000000)"
        filter="url(#filter-1)"
      >
        <g id="Icon-24px">
          <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
          <path
            d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M12,5 C13.66,5 15,6.34 15,8 C15,9.66 13.66,11 12,11 C10.34,11 9,9.66 9,8 C9,6.34 10.34,5 12,5 L12,5 Z M12,19.2 C9.5,19.2 7.29,17.92 6,15.98 C6.03,13.99 10,12.9 12,12.9 C13.99,12.9 17.97,13.99 18,15.98 C16.71,17.92 14.5,19.2 12,19.2 L12,19.2 Z"
            id="Shape"
            fill="#000000"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const CameraAlt = (
  <svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1">
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="ic_camera_alt">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <circle id="Oval" fill="#77A792" cx="12" cy="12" r="3.2"></circle>
        <path
          d="M9,2 L7.17,4 L4,4 C2.9,4 2,4.9 2,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 L16.83,4 L15,2 L9,2 L9,2 Z M12,17 C9.24,17 7,14.76 7,12 C7,9.24 9.24,7 12,7 C14.76,7 17,9.24 17,12 C17,14.76 14.76,17 12,17 L12,17 Z"
          id="Shape"
          fill="#77A792"
        ></path>
      </g>
    </g>
  </svg>
);

export const Help = (
  <svg width="100%" height="100%" viewBox="0 0 21 24" version="1.1">
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.957693 0 0 0 0 0.918407 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="ic_help" filter="url(#filter-1)">
        <g id="Icon-24px">
          <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
          <path
            d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M13,19 L11,19 L11,17 L13,17 L13,19 L13,19 Z M15.07,11.25 L14.17,12.17 C13.45,12.9 13,13.5 13,15 L11,15 L11,14.5 C11,13.4 11.45,12.4 12.17,11.67 L13.41,10.41 C13.78,10.05 14,9.55 14,9 C14,7.9 13.1,7 12,7 C10.9,7 10,7.9 10,9 L8,9 C8,6.79 9.79,5 12,5 C14.21,5 16,6.79 16,9 C16,9.88 15.64,10.68 15.07,11.25 L15.07,11.25 Z"
            id="Shape"
            fill="#000000"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const InsertPhoto = (
  <svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1">
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="ic_insert_photo">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path
          d="M21,19 L21,5 C21,3.9 20.1,3 19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,19 Z M8.5,13.5 L11,16.51 L14.5,12 L19,18 L5,18 L8.5,13.5 L8.5,13.5 Z"
          id="Shape"
          fill="#77A792"
        ></path>
      </g>
    </g>
  </svg>
);

export const Mic = (
  <svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1">
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="ic_mic">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path
          d="M12,14 C13.66,14 14.99,12.66 14.99,11 L15,5 C15,3.34 13.66,2 12,2 C10.34,2 9,3.34 9,5 L9,11 C9,12.66 10.34,14 12,14 L12,14 Z M17.3,11 C17.3,14 14.76,16.1 12,16.1 C9.24,16.1 6.7,14 6.7,11 L5,11 C5,14.41 7.72,17.23 11,17.72 L11,21 L13,21 L13,17.72 C16.28,17.24 19,14.42 19,11 L17.3,11 L17.3,11 Z"
          id="Shape"
          fill="#77A792"
        ></path>
      </g>
    </g>
  </svg>
);

export const Home = (
  <svg width="100%" height="100%" viewBox="0 0 20 17" version="1.1">
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.957693 0 0 0 0 0.918407 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="ic_home"
        transform="translate(-2.000000, -3.000000)"
        filter="url(#filter-1)"
      >
        <g id="Icon-24px">
          <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
          <polygon
            id="Shape"
            fill="#000000"
            points="10 20 10 14 14 14 14 20 19 20 19 12 22 12 12 3 2 12 5 12 5 20"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export const LeftChevron = (
  <svg width="100%" height="100%" viewBox="0 0 8 12" version="1.1">
    <title>left-chevron</title>
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" transform="translate(-8.000000, -6.000000)">
        <g
          id="Hamburger"
          transform="translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) "
        >
          <polygon
            id="Shape"
            opacity="0"
            points="0 0 24 0 24 24 0 24"
          ></polygon>
          <polygon
            id="Shape"
            fill="#F6F7F7"
            points="10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export const Reveal = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#CAC3BB"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
  </svg>
);

export const RightChevron = (
  <svg width="100%" height="100%" viewBox="0 0 8 12" version="1.1">
    <g id="Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Right-Icon" transform="translate(-8.000000, -6.000000)">
        <polygon id="State" points="0 0 24 0 24 24 0 24"></polygon>
        <polygon
          id="Shape"
          fill="#706C68"
          points="10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12"
        ></polygon>
      </g>
    </g>
  </svg>
);

export const Elipses = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="black"
    width="100%"
    height="100%"
  >
    <title>elipses</title>
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      fill="#FFF4EA"
    />
  </svg>
);

export const ManageUsers = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 24 24"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
  >
    <title>manage-users</title>
    <g>
      <rect fill="none" height="24" width="24" stroke="none" />
    </g>
    <g>
      <path d="M13,8c0-2.21-1.79-4-4-4S5,5.79,5,8s1.79,4,4,4S13,10.21,13,8z M15,10v2h3v3h2v-3h3v-2h-3V7h-2v3H15z M1,18v2h16v-2 c0-2.66-5.33-4-8-4S1,15.34,1,18z" />
    </g>
  </svg>
);

export const TrashCan = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

export const PlusMark = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
  </svg>
);

export const Pencil = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    fill="#000000"
  >
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <g>
        <g>
          <polygon points="3,17.25 3,21 6.75,21 17.81,9.94 14.06,6.19" />
        </g>
        <g>
          <path d="M20.71,5.63l-2.34-2.34c-0.39-0.39-1.02-0.39-1.41,0l-1.83,1.83l3.75,3.75l1.83-1.83C21.1,6.65,21.1,6.02,20.71,5.63z" />
        </g>
      </g>
    </g>
  </svg>
);

export const Download = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
  >
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z" />
    </g>
  </svg>
);

export const Hide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#CAC3BB"
  >
    <path
      d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
      fill="none"
    />
    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
  </svg>
);

export const Add = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#206334"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
  </svg>
);

export const Clear = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
  </svg>
);

export const AttachFile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    fill="#000000"
  >
    <path d="M11.5 22.225q-2.4 0-4.062-1.663Q5.775 18.9 5.775 16.5V5.9q0-1.725 1.225-2.95t2.95-1.225q1.725 0 2.963 1.225Q14.15 4.175 14.15 5.9v9.55q0 1.1-.775 1.875-.775.775-1.875.775t-1.875-.775q-.775-.775-.775-1.875V5.9h1.7v9.55q0 .4.275.675t.675.275q.4 0 .675-.275t.275-.675V5.9q0-1.05-.725-1.775Q11 3.4 9.95 3.4q-1.05 0-1.775.725Q7.45 4.85 7.45 5.9v10.6q0 1.675 1.188 2.863Q9.825 20.55 11.5 20.55t2.863-1.187q1.187-1.188 1.187-2.863V5.9h1.675v10.6q0 2.4-1.663 4.062-1.662 1.663-4.062 1.663Z" />
  </svg>
);

export const Search = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 960 960"
    width="24px"
  >
    <path d="M796 935 533 672q-30 26-69.959 40.5T378 727q-108.162 0-183.081-75Q120 577 120 471t75-181q75-75 181.5-75t181 75Q632 365 632 471.15 632 514 618 554q-14 40-42 75l264 262-44 44ZM377 667q81.25 0 138.125-57.5T572 471q0-81-56.875-138.5T377 275q-82.083 0-139.542 57.5Q180 390 180 471t57.458 138.5Q294.917 667 377 667Z" />
  </svg>
);

export const Warning = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="50"
    viewBox="0 -960 960 960"
    width="50"
  >
    <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" />
  </svg>
);

export const ImageDownload = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -22 120 145">
    <path d="M0,0H120.59V93.72H87.84V83.64H109.5V10.08H11.1V83.64H32.2V93.72H0V0ZM51.64,101.3V83.63H68.51V101.3H80.73L60.31,122.88,39.85,101.3ZM33.92,24.93a7.84,7.84,0,1,1-7.85,7.84,7.85,7.85,0,0,1,7.85-7.84Zm33,33.66L82.62,31.46,99.29,73.62H21.5V68.39L28,68.07l6.53-16,3.27,11.44h9.8l8.5-21.89,10.79,17Z" />
  </svg>
);

export const BusySign = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
    <path fill="#000000" stroke="#000000" stroke-width="15" transform-origin="center" d="m148 84.7 13.8-8-10-17.3-13.8 8a50 50 0 0 0-27.4-15.9v-16h-20v16A50 50 0 0 0 63 67.4l-13.8-8-10 17.3 13.8 8a50 50 0 0 0 0 31.7l-13.8 8 10 17.3 13.8-8a50 50 0 0 0 27.5 15.9v16h20v-16a50 50 0 0 0 27.4-15.9l13.8 8 10-17.3-13.8-8a50 50 0 0 0 0-31.7Zm-47.5 50.8a35 35 0 1 1 0-70 35 35 0 0 1 0 70Z">
      <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="0;120" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite" />
    </path>
  </svg>
)